import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

const REMINDER_INTERVALS = ['daily', 'every-other-day', 'off', 'weekly'];

export default Factory.extend({
  canAccessSlack: false,
  notificationsEnabled: true,
  emailNotificationsEnabled: false,
  notificationDelay: 0,
  slackNotificationsEnabled: false,

  notificationReminderInterval: () => faker.helpers.arrayElement(REMINDER_INTERVALS),
});
